import React from 'react';

import NetInfo from '@react-native-community/netinfo';
import { useSelector } from '@xstate5/react';
import { type ActorRefFrom, type SnapshotFrom } from 'xstate5';

import { type networkMonitorMachine } from './NetworkMonitor.machine';

type Machine = ActorRefFrom<typeof networkMonitorMachine>;

export const useNetworkMonitor = (machine: Machine) => {
  React.useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      machine.send({ type: state.isConnected ? 'CONNECT' : 'DISCONNECT' });
    });

    return unsubscribe;
  }, [machine]);

  return useNetworkStatus(machine);
};

export const useNetworkStatus = (machine: Machine) => {
  return useSelector(machine, checkIfConnected);
};

function checkIfConnected(snapshot: SnapshotFrom<Machine>) {
  return snapshot.value === 'connected';
}
